import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import * as actions from './actions';
import CommentEditor from './commentEditor';
import CommentList from './commentList';
import { useActions } from 'hooks/useActions';
import { ContainerRow, ContainerColumn } from './styles';

export default function CommentContainer({ testId, contestId }) {
  const { getRootComments } = useActions(actions);
  const {
    error,
    createCommentError,
    rootCommentIds: { [contestId || testId]: commentIds },
    rootCommentsLoading,
  } = useSelector((state) => state.comments);
  const { isCommunityUser } = useSelector((state) => state.auth);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  useEffect(() => {
    if (createCommentError) {
      toast.error(createCommentError);
    }
  }, [createCommentError]);

  useEffect(() => {
    if (!commentIds?.length && (testId || contestId)) {
      getRootComments(testId, contestId);
    }
  }, [testId, contestId, commentIds?.length, getRootComments]);

  return (
    <ContainerRow>
      <ContainerColumn>
        {!isCommunityUser && <p>Join the community to comment</p>}
        {isCommunityUser && <CommentEditor testId={testId} contestId={contestId} />}
        <CommentList commentIds={commentIds} loading={rootCommentsLoading} />
        {isCommunityUser && !commentIds?.length && !rootCommentsLoading && (
          <p>Be the first to contribute to the discussion</p>
        )}
      </ContainerColumn>
    </ContainerRow>
  );
}
